import { render, staticRenderFns } from "./EditExtensionDetailModal.vue?vue&type=template&id=6d3293bb&"
import script from "./EditExtensionDetailModal.vue?vue&type=script&lang=js&"
export * from "./EditExtensionDetailModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports